var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6722 18.6804C17.8568 18.6804 18.021 18.5632 18.0808 18.3886L20.3427 11.7931C20.4008 11.6237 20.3483 11.4359 20.2107 11.3212L12.4496 4.85084C12.1509 4.6018 11.7169 4.6018 11.4182 4.85084L3.75327 11.241C3.6176 11.3541 3.56447 11.5384 3.61911 11.7064L5.78998 18.382C5.84781 18.56 6.01365 18.6804 6.20075 18.6804H17.6722Z",
    fill: "#FD6050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6581 9.47852C17.9311 9.47852 18.0911 9.78572 17.9347 10.0094L11.8714 18.6812L5.80802 10.0094C5.6516 9.78572 5.81164 9.47852 6.08458 9.47852H17.6581Z",
    fill: "#D63B78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38023 7.15498V2.26934C6.38023 2.00026 6.02404 1.90477 5.88946 2.13776L3.57623 6.14162L6.38023 7.15498Z",
    fill: "#FD6050"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88965 7.80187L3.34598 6.18766C3.12998 6.1109 2.92602 6.32799 3.016 6.53881L4.70377 10.4931L7.88965 7.80187Z",
    fill: "#D63B78"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5082 6.12776L18.1104 2.1319C17.9758 1.89891 17.6196 1.9944 17.6196 2.26348V7.16136L20.5082 6.12776Z",
    fill: "#FD6050"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1608 10.4935L20.8751 6.45092C20.9651 6.2401 20.7611 6.02301 20.5451 6.09977L15.8804 7.75868L19.1608 10.4935Z",
    fill: "#D63B78"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89072 17.8104L2.98135 21.7713C2.94601 22.0442 2.56832 22.0864 2.47354 21.828L0.802246 17.2715L3.89072 17.8104Z",
    fill: "#FD6050"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56108 17.8104L0.656708 17.1892C0.410685 17.157 0.341979 16.8333 0.553791 16.7039L4.42993 14.332L5.56108 17.8104Z",
    fill: "#D63B78"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1978 17.2715L21.5266 21.8281C21.4318 22.0864 21.0541 22.0442 21.0188 21.7713L20.366 17.8104L23.1978 17.2715Z",
    fill: "#FD6050"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2646 17.9697L23.3004 17.3064C23.5464 17.2742 23.6151 16.9504 23.4033 16.8211L19.4719 14.4492L18.2646 17.9697Z",
    fill: "#D63B78"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38054 7.14908V2.26348C6.38054 1.9944 6.02435 1.89891 5.88976 2.1319L3.57654 6.13576",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89078 17.8104L2.98141 21.7713C2.94607 22.0442 2.56838 22.0864 2.4736 21.828L0.802307 17.2715",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6199 7.16136V2.26348C17.6199 1.9944 17.9761 1.89891 18.1106 2.1319L20.5084 6.12776",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3663 17.8104L21.019 21.7713C21.0544 22.0442 21.4321 22.0865 21.5268 21.8281L23.1981 17.2715",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6724 18.6804C17.8569 18.6804 18.0211 18.5632 18.081 18.3886L20.3429 11.7931C20.401 11.6237 20.3485 11.4359 20.2109 11.3212L12.4497 4.85084C12.151 4.6018 11.717 4.6018 11.4183 4.85084L3.75339 11.241C3.61772 11.3541 3.56459 11.5384 3.61923 11.7064L5.7901 18.382C5.84793 18.56 6.01377 18.6804 6.20087 18.6804H17.6724Z",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88995 7.75695L3.34628 6.14274C3.13028 6.06598 2.92633 6.28307 3.01631 6.49389L4.70407 10.4482",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60424 17.8104L0.69986 17.1892C0.453837 17.157 0.385131 16.8333 0.596943 16.7039L4.47308 14.332",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9894 7.80165L20.6541 6.14274C20.8701 6.06598 21.0741 6.28307 20.9841 6.49389L19.2698 10.5364",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2648 17.8525L23.3005 17.1892C23.5465 17.157 23.6152 16.8333 23.4034 16.7039L19.4721 14.332",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantIcon7);
export default __webpack_public_path__ + "static/media/assistant-icon-7.3bade22f8c56c1e964e19b04f1ccb62e.svg";
export { ForwardRef as ReactComponent };